.body {
  display: flex;
  flex-direction: column;
}

.centered-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
